var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bc19",
    d: "M78 13A1 1 0 1 0 78 15A1 1 0 1 0 78 13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fce0a2",
    d: "M50 12A38 38 0 1 0 50 88A38 38 0 1 0 50 12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bc19",
    d: "M84 12A4 4 0 1 0 84 20A4 4 0 1 0 84 12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ee3e54",
    d: "M14 24A2 2 0 1 0 14 28A2 2 0 1 0 14 24Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbcd59",
    d: "M78 75A2 2 0 1 0 78 79 2 2 0 1 0 78 75zM17 74A4 4 0 1 0 17 82 4 4 0 1 0 17 74z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ee3e54",
    d: "M24 81A2 2 0 1 0 24 85A2 2 0 1 0 24 81Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M66.483 76.03399999999999A2.483 2.483 0 1 0 66.483 81 2.483 2.483 0 1 0 66.483 76.03399999999999zM16 47A1 1 0 1 0 16 49 1 1 0 1 0 16 47z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bc19",
    d: "M86 30A1 1 0 1 0 86 32A1 1 0 1 0 86 30Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80 64A2 2 0 1 0 80 68A2 2 0 1 0 80 64Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#508ecc",
    d: "M34.725,23.017C42.793,23.397,49,30.347,49,38.424V46h-6v-7.692c0-4.794-3.617-8.979-8.401-9.289 C29.357,28.68,25,32.831,25,38c0,1.657-1.343,3-3,3s-3-1.343-3-3C19,29.475,26.111,22.611,34.725,23.017z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M34,24.4c0.219,0,0.438,0.005,0.659,0.016C41.916,24.757,47.6,30.91,47.6,38.424V44.6h-3.2v-6.292 c0-5.64-4.265-10.333-9.711-10.686C34.458,27.607,34.228,27.6,34,27.6c-5.735,0-10.4,4.665-10.4,10.4c0,0.882-0.718,1.6-1.6,1.6 s-1.6-0.718-1.6-1.6C20.4,30.501,26.501,24.4,34,24.4 M34,23c-8.284,0-15,6.716-15,15c0,1.657,1.343,3,3,3s3-1.343,3-3 c0-4.971,4.029-9,9-9c0.198,0,0.398,0.006,0.599,0.019C39.383,29.329,43,33.515,43,38.308V46h6v-7.576 c0-8.077-6.207-15.027-14.275-15.407C34.482,23.006,34.241,23,34,23L34,23z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#7dafe2",
    d: "M66,72H46c-5.523,0-10-4.477-10-10V48c0-2.209,1.791-4,4-4h32c2.209,0,4,1.791,4,4v14 C76,67.523,71.523,72,66,72z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#7dafe2",
    d: "M66,72H46c-5.523,0-10-4.477-10-10V48c0-2.209,1.791-4,4-4h32c2.209,0,4,1.791,4,4v14 C76,67.523,71.523,72,66,72z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bc19",
    d: "M37 49H75V55.5H37z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#508ecc",
    d: "M58,61c0-1.105-0.895-2-2-2s-2,0.895-2,2c0,0.653,0.318,1.227,0.801,1.592L54,67h4l-0.801-4.408 C57.682,62.227,58,61.653,58,61z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M72,45.4c1.434,0,2.6,1.166,2.6,2.6v14c0,4.742-3.858,8.6-8.6,8.6H46c-4.742,0-8.6-3.858-8.6-8.6V48 c0-1.434,1.166-2.6,2.6-2.6H72 M72,44H40c-2.209,0-4,1.791-4,4v14c0,5.523,4.477,10,10,10h20c5.523,0,10-4.477,10-10V48 C76,45.791,74.209,44,72,44L72,44z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M75 50h-3.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5H75c.276 0 .5.224.5.5S75.276 50 75 50zM68.5 50h-2c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h2c.276 0 .5.224.5.5S68.776 50 68.5 50zM63.5 50H37c-.276 0-.5-.224-.5-.5S36.724 49 37 49h26.5c.276 0 .5.224.5.5S63.776 50 63.5 50zM75 56H37c-.276 0-.5-.224-.5-.5S36.724 55 37 55h38c.276 0 .5.224.5.5S75.276 56 75 56zM56 59.35c.91 0 1.65.74 1.65 1.65 0 .517-.241.995-.662 1.313-.106.08-.157.212-.134.342l.726 3.995h-3.161l.726-3.995c.024-.13-.028-.262-.134-.342C54.591 61.995 54.35 61.517 54.35 61 54.35 60.09 55.09 59.35 56 59.35M56 59c-1.105 0-2 .895-2 2 0 .653.318 1.227.801 1.592L54 67h4l-.801-4.408C57.682 62.227 58 61.653 58 61 58 59.895 57.105 59 56 59L56 59z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M35.44 52.325H42.769999999999996V52.676H35.44z",
    transform: "rotate(-54.984 39.102 52.498)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M39.23 52.325H46.559999999999995V52.676H39.23z",
    transform: "rotate(-54.984 42.892 52.498)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M42.94 52.325H50.269999999999996V52.676H42.94z",
    transform: "rotate(-54.984 46.602 52.498)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M46.73 52.325H54.059999999999995V52.676H46.73z",
    transform: "rotate(-54.984 50.392 52.499)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M50.44 52.325H57.769999999999996V52.676H50.44z",
    transform: "rotate(-54.984 54.101 52.499)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M54.23 52.325H61.559999999999995V52.676H54.23z",
    transform: "rotate(-54.984 57.891 52.499)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M57.94 52.325H65.27V52.676H57.94z",
    transform: "rotate(-54.984 61.601 52.499)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M61.73 52.325H69.06V52.676H61.73z",
    transform: "rotate(-54.984 65.391 52.499)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M65.44 52.325H72.77V52.676H65.44z",
    transform: "rotate(-54.984 69.1 52.499)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M69.23 52.325H76.56V52.676H69.23z",
    transform: "rotate(-54.984 72.89 52.499)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/unlocked.0f67e60bd1c35e1be3ed9bd37b33f007.svg";
export { ForwardRef as ReactComponent };